<template>
    <div
        :data-component="$options.name"
        class="inset-x-0 bottom-40 max-w-[485px] mx-auto px-20 z-overlay-canvas screen-m:px-0"
        :class="{ absolute: isLocalToastManager }"
    >
        <TransitionGroup
            tag="ul"
            enter-active-class="transition-all duration-[400ms] ease-[cubic-bezier(0.21,0.61,0.35,1)]"
            leave-active-class="transition-all duration-[400ms] ease-[cubic-bezier(0.21,0.61,0.35,1)] absolute inset-x-0"
            move-class="transition-all duration-[400ms] ease-[cubic-bezier(0.21,0.61,0.35,1)]"
            leave-to-class="opacity-0"
            enter-class="translate-y-[100px] opacity-0"
        >
            <cs-toast
                v-for="toast in toasts"
                :key="toast.id"
                :type="toast.type"
                class="mt-20"
                @close="removeId(toast.id)"
                @mouseleave="startTimeout(toast.id)"
                @mouseenter="stopTimeout(toast.id)"
            >
                <template v-if="isAdded(toast)">
                    <div data-jest-added>
                        Das Angebot wurde zu deiner
                        <a
                            class="text-white underline cursor-pointer hover:text-white hover:underline"
                            @click="openBookmarks(toast)"
                            >Merkliste</a
                        >
                        hinzugefügt.
                    </div>
                </template>
                <template v-else-if="isRemoved(toast)">
                    <div data-jest-removed>
                        Das Angebot wurde von deiner
                        <a
                            class="text-white underline cursor-pointer hover:text-white hover:underline"
                            @click="openBookmarks(toast)"
                            >Merkliste</a
                        >
                        entfernt.
                    </div>
                </template>
                <template v-else-if="isRemovedCanRevert(toast)">
                    <div data-jest-removedcanrevert>
                        Das Angebot wurde von deiner Merkliste entfernt.
                        <a
                            class="text-white underline cursor-pointer hover:text-white hover:underline"
                            @click="restoreBookmark(toast)"
                            >Rückgängig machen</a
                        >
                    </div>
                </template>
                <template v-else-if="isFull(toast)">
                    <div data-jest-full>
                        Deine
                        <a
                            class="text-white underline cursor-pointer hover:text-white hover:underline"
                            @click="openBookmarks(toast)"
                            >Merkliste</a
                        >
                        ist voll (20/20). Bitte lösche Angebote, um neue hinzufügen zu können.
                    </div>
                </template>
                <template v-else-if="isNotAvailable(toast)">
                    <div data-jest-notavailable>
                        Um dieses Angebot merken zu können, brauchen wir deine Zustimmung. Bitte passe deine
                        Privatsphäre-Einstellungen
                        <a
                            class="text-white underline cursor-pointer hover:text-white hover:underline"
                            @click="openCookieConsent(toast)"
                            >hier</a
                        >
                        an.
                    </div>
                </template>
            </cs-toast>
        </TransitionGroup>
    </div>
</template>
<script lang="ts" src="./MsToastManager.ts" />
